// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"Select_selectWrapper__tncVI","marginBottom":"Select_marginBottom__1xY8P","select":"Select_select__hhi0_","label":"Select_label__1bIW3"};